import { TaskMetricSection } from '../TaskMetricSection';
import { GridItem, HStack, Text, VStack } from '@cdl/heartbeat-react';
import { AnnotationTask } from '../../../../ecg/types/annotation-tasks.type';
import { OverallCount } from './OverallCount';
import { OverallDonut } from './OverallDonut';

type Props = {
  annotationTask: AnnotationTask;
};

export const OverallPerformance: React.FC<Props> = ({ annotationTask }) => {
  return (
    <GridItem colSpan={1}>
      <TaskMetricSection>
        <Text textStyle='category-title'>Overall Performance</Text>
        <HStack mt='m'>
          <OverallDonut annotationTask={annotationTask} />
          <VStack alignItems='left' spacing='s'>
            <OverallCount annotationTask={annotationTask} status='done' />
            <OverallCount annotationTask={annotationTask} status='pending' />
            <OverallCount annotationTask={annotationTask} status='toStart' />
          </VStack>
        </HStack>
      </TaskMetricSection>
    </GridItem>
  );
};
